import React, { useState, useRef, useEffect } from 'react';
import { createPortal } from 'react-dom';
import '../inventoryHistoryV2.css';

/**
 * Component to display tooltips for table headers
 * Uses portals to render tooltips outside of container bounds
 * 
 * @param {string} label - The header label to display
 * @param {string} tooltip - The tooltip text
 * @param {string} className - Additional CSS classes
 */
const HeaderTooltip = ({ label, tooltip, className = '' }) => {
    const [showTooltip, setShowTooltip] = useState(false);
    const [position, setPosition] = useState({ left: 0, top: 0 });
    const containerRef = useRef(null);
    
    // Calculate position of the tooltip
    const calculatePosition = () => {
        if (containerRef.current) {
            const containerRect = containerRef.current.getBoundingClientRect();
            
            setPosition({
                left: containerRect.left + containerRect.width / 2,
                top: containerRect.top - 8
            });
        }
    };
    
    // Handle showing the tooltip
    const handleMouseEnter = () => {
        setShowTooltip(true);
        setTimeout(calculatePosition, 0);
    };
    
    // Handle hiding the tooltip
    const handleMouseLeave = () => {
        setShowTooltip(false);
    };
    
    // Add window resize and scroll listeners
    useEffect(() => {
        if (showTooltip) {
            window.addEventListener('resize', calculatePosition);
            window.addEventListener('scroll', calculatePosition, true);
            
            return () => {
                window.removeEventListener('resize', calculatePosition);
                window.removeEventListener('scroll', calculatePosition, true);
            };
        }
    }, [showTooltip]);
    
    // Render the tooltip content
    const renderTooltipContent = () => {
        return (
            <div 
                className="header-tooltip-content tooltip-popup inventory-history-v2"
                style={{ left: position.left, top: position.top }}
            >
                {tooltip}
                <div className="header-tooltip-arrow"></div>
            </div>
        );
    };
    
    return (
        <div 
            className={`header-tooltip-trigger inventory-history-v2 ${className}`}
            onMouseEnter={handleMouseEnter}
            onMouseLeave={handleMouseLeave}
            ref={containerRef}
        >
            {label}
            
            {showTooltip && createPortal(
                renderTooltipContent(),
                document.body
            )}
        </div>
    );
};

export { HeaderTooltip }; 